//* Necessary for typing in actions and getters.
/* eslint-disable @typescript-eslint/no-use-before-define, no-use-before-define */

import { ActionContext } from 'vuex';
import { cloneDeep } from 'lodash';
import { useFirestore } from '@/services';
import * as App from '@/types/app';
import * as Database from '@/types/database';
import { emptyValues, formDefaults } from '@/constants';
import { mapAppBidToDatabaseBid, mapDatabaseBidToAppBid } from '@/utils';
import { defineCustomFirebaseCollectionStoreModule } from './base-module';
import { moduleActionContext, moduleGetterContext } from '..';

const { useBidOperators } = useFirestore();
export const bidsModule = defineCustomFirebaseCollectionStoreModule<
  App.Bid,
  Database.Bid,
  {
    localBid: App.Bid;
  }
>(
  useBidOperators,
  {
    state: {
      localBid: formDefaults.localBid
    },
    getters: {
      getLocalBid: (...context): App.Bid => {
        const { state } = getterContext(context);

        return state.data.localBid;
      }
    },
    mutations: {
      UPDATE_LOCAL_BID: (state, payload: App.Bid) => {
        state.data.localBid = payload;
      }
    },
    actions: {
      updateLocalBid: (context, payload: Partial<App.Bid>): void => {
        const { commit, state } = actionContext(context);

        const updatedLocalBid = {
          ...state.data.localBid,
          ...payload,
          materialList: cloneDeep(payload.materialList ?? state.data.localBid.materialList)
        };

        commit.UPDATE_LOCAL_BID(updatedLocalBid);
      },
      clearLocalBid: (context): void => {
        const { commit, rootDispatch } = actionContext(context);

        rootDispatch.internal.update(['jobName', '']);
        rootDispatch.internal.update(['linkedClientSelect', emptyValues.client]);
        rootDispatch.internal.update(['linkedLocation', emptyValues.geoPoint]);
        commit.UPDATE_LOCAL_BID(formDefaults.localBid);
      }
    }
  },
  {
    databaseModelToAppModel: mapDatabaseBidToAppBid,
    appModelToDatabaseModel: mapAppBidToDatabaseBid
  }
);
bidsModule.state.data.localBid;
const getterContext = (args: [unknown, unknown, unknown, unknown]) => moduleGetterContext(args, bidsModule);
const actionContext = (context: ActionContext<unknown, unknown>) => moduleActionContext(context, bidsModule);
